import BlurOn from '@mui/icons-material/BlurOn';

export default function BulletListComponent( { item } ){
    const emojis = ['🏀','⚽️'];
    const emoji = Math.random() < 0.5 ? emojis[0] : emojis[1];
    
    return(
        <div className = "bullet" key = { item.id } >
            {/* <p>{ emoji }</p> */}
            <BlurOn sx={{ fontSize: 10, color: "var(--black16)", marginTop : "6px" }} />
            <p style = { { lineHeight : "140%" }}>{ item[item.type].rich_text[0].plain_text }</p>
        </div>
    )
}